import { userLevelCode } from '@/constants/userLevel';
/** 권한 설정이 허용 된 레벨 목록 */
export const permissionSettingRequiredLevelList = [
    userLevelCode[32].value,
    userLevelCode[42].value,
];
